module.exports = __webpack_public_path__ + "img/cde2973.webp";